import React from 'react';
import ZinantisRequestsFiltersBar from './ZinantisRequestsFiltersBar';
import ZinantisRequestsList from './ZinantisRequestsList';
import { useConnectionRequests } from '../../../contextsProperty/ContextConnectionRequests';

const ZinantisRequestsSection = () => {
    const { isCollapsed } = useConnectionRequests();
    return (
        <div
            className={`connection-requests__section  ${
                isCollapsed ? '' : 'flex-grow min-height-40perc'
            }`}
        >
            <ZinantisRequestsFiltersBar />
            {!isCollapsed && <ZinantisRequestsList />}
        </div>
    );
};

export default ZinantisRequestsSection;
